<template>
	<!-- A v-btn with a styled tooltip in place of the browser's title tooltip. Attributes and listeners pass through
	     to the button, so callers write it like a v-btn; aria-label stays the accessible name, tip is the short label. -->
	<v-tooltip
		:top="placement === 'top'"
		:bottom="placement === 'bottom'"
		:left="placement === 'left'"
		open-delay="350"
		:z-index="10010"
		content-class="assistant-tooltip"
	>
		<template #activator="{ on, attrs }">
			<v-btn v-bind="{ ...attrs, ...$attrs }" v-on="{ ...on, ...$listeners }">
				<slot></slot>
			</v-btn>
		</template>
		<span>{{ tip }}</span>
	</v-tooltip>
</template>

<script>
export default {
	name: "AssistantIconButton",
	inheritAttrs: false,
	props: {
		tip: { type: String, required: true },
		placement: { type: String, default: "bottom", validator: (v) => ["top", "bottom", "left"].includes(v) },
	},
};
</script>
